import { Formik } from 'formik';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/button';
import FileUpload from '../../components/FileUpload';
import Input from '../../components/input';
import Select from '../../components/Select';
import { fetchIssues, getIssueTagsDropdown, issueLastId } from '../../store/Slices/IssuesSlice';
import { createServiceIssue, fetchVehicleDetail, fetchVehicleDropdown } from '../../store/Slices/ServiceSlice';
import { getUserDropdown } from '../../store/Slices/UserSlice';
import '../../styles/Issue.css';
import { priorityOptions } from '../../utils/Dropdowns';
import { IssueValidationSchema } from '../../utils/Schema';
import { errorNotify, successNotify } from '../../utils/toast';

const CreateIssue = ({ onClose, searchText, searchFilters, currentPage, limit }) => {
    const dispatch = useDispatch();

    const userDetails = JSON.parse(localStorage.getItem("fms-maintenance-details"));

    const { loading, vehicleData, createIssueLoading, vehicleDetail, } = useSelector((state) => state.services);
    const { userDropdownLoading, userDropdownData } = useSelector((state) => state.users)
    const { issueLastIdData, getIssueTagsDropdownData,
        getIssueTagsDropdownLoading } = useSelector((state) => state.issues);

    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [selectedVehicle, setSelectedVehicle] = useState(null);

    useEffect(() => {
        dispatch(getUserDropdown());
        dispatch(issueLastId());
        dispatch(fetchVehicleDropdown())
        dispatch(getIssueTagsDropdown())
    }, [])

    const userOptions = userDropdownData && userDropdownData.map(user => ({
        value: user.value,
        label: user.label,
        image: user.image,
        showIcon: true
    }));

    const tagsOptions = getIssueTagsDropdownData?.map(tag => ({ label: tag.tag_name, value: tag.tag_name }));

    const handleVehicleChange = async (selectedOption, setFieldValue) => {
        setSelectedVehicle(selectedOption);
        setFieldValue('vehicle_id', selectedOption?.value || '');

        if (selectedOption) {
            const response = await dispatch(fetchVehicleDetail({
                vehicleId: selectedOption.value,
                vehicleBrandId: selectedOption.brand_id,
                ref_id: selectedOption.ref_id
            })).unwrap();

            setFieldValue('odo_meter', response?.data?.last_service?.odo_meter || null);
            setFieldValue('odm', response?.data?.odm || '');
        }
    };

    const initialValues = {
        vehicle_id: vehicleDetail?.id || '',
        service_id: 456,
        reported_by: userDetails?.id || '',
        assign_to: '',
        odo_meter: vehicleDetail?.odm || '',
        odm: vehicleDetail?.odm || '',
        priority: '',
        status: 'open',
        summery: '',
        description: '',
        reported_at: '',
        reported_time: '',
        tags: [],
        files: []
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            const issueData = {
                vehicle_id: parseInt(values.vehicle_id),
                reported_by: parseInt(values.reported_by),
                assign_to: parseInt(values.assign_to),
                odo_meter: parseInt(values.odm),
                priority: values.priority,
                status: values.status,
                summery: values.summery,
                description: values.description,
                reported_at: new Date(values.reported_at).toISOString(),
                tags: values.tags.map(tag => tag.value || tag),
                files: uploadedFiles.map(file => file.fileName)
            };

            await dispatch(createServiceIssue(issueData)).unwrap();
            successNotify('Issue created successfully');
            onClose();
            resetForm();

            if (searchText.length > 0 || searchFilters) {
                dispatch(fetchIssues({
                    page: currentPage,
                    limit: limit,
                    search_text: searchText,
                    searchFilters: searchFilters
                }));
            }
            else {
                dispatch(fetchIssues({
                    page: currentPage,
                    limit: limit,
                }));
            }


        } catch (error) {
            errorNotify(error);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={IssueValidationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}
        >
            {({ values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting, submitForm }) => (
                <div>
                    <Row>
                        <Col md={12}>
                            <div className='show_issue_id'>
                                Issue ID: <span>SI-{issueLastIdData + 1 || '0000'}</span>
                            </div>
                        </Col>
                        <Col md={12}>
                            <Select
                                label="Vehicle"
                                placeholder="Select Vehicle"
                                options={vehicleData}
                                loading={loading}
                                name="vehicle_id"
                                value={selectedVehicle}
                                onChange={(selectedOption) => handleVehicleChange(selectedOption, setFieldValue)}
                                onBlur={handleBlur}
                                error={errors.vehicle_id}
                                touched={touched.vehicle_id}
                                isSearch={false}
                            />
                        </Col>
                        <Col md={12}>
                            <Select
                                label="Priority"
                                placeholder="Select Priority"
                                options={priorityOptions}
                                loading={false}
                                name="priority"
                                value={priorityOptions.find(option => option.value === values.priority)}
                                onChange={(selectedOption) => setFieldValue('priority', selectedOption?.value || '')}
                                onBlur={handleBlur}
                                error={errors.priority}
                                touched={touched.priority}
                                isSearch={false}
                            />
                        </Col>
                        <Col md={12}>
                            <Input
                                label="Reported Date & Time"
                                placeholder=""
                                type="datetime-local"
                                name="reported_at"
                                value={values.reported_at}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.reported_at}
                                touched={touched.reported_at}
                            />
                        </Col>
                        <Col md={12}>
                            <Input
                                label="Summary"
                                placeholder="Brief overview of the issue"
                                type="text"
                                name="summery"
                                value={values.summery}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.summery}
                                touched={touched.summery}
                            />
                        </Col>
                        <Col md={12}>
                            <Input
                                label="Description (Optional)"
                                placeholder="Add issue description"
                                type="text"
                                name="description"
                                value={values.description}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.description}
                                touched={touched.description}
                                quill={true}
                                setFieldValue={setFieldValue}
                            />
                        </Col>
                        <Col md={12}>
                            <Select
                                label="Tags"
                                placeholder="Type and press Enter to create tags"
                                options={tagsOptions}
                                loading={getIssueTagsDropdownLoading}
                                name="tags"
                                value={values.tags}
                                onChange={(selectedOptions) => setFieldValue('tags', selectedOptions || [])}
                                onBlur={handleBlur}
                                isMulti={true}
                                isCreatable={true}
                                error={errors.tags && typeof errors.tags === 'string' ? errors.tags : null}
                                touched={touched.tags}
                            />
                        </Col>
                        <Col md={12}>
                            <Input
                                label="Primary Meter"
                                placeholder="Enter Primary Meter Reading"
                                type="number"
                                name="odm"
                                showExtraText={vehicleDetail ? true : false}
                                extraText={`Last Recorded: ${values?.odo_meter || 0} KM`}
                                value={values.odm}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.odm}
                                touched={touched.odm}
                            />
                        </Col>
                        <Col md={12}>
                            <Select
                                label="Reported By"
                                placeholder="Please Select"
                                options={userOptions}
                                loading={userDropdownLoading}
                                name="reported_by"
                                value={userOptions.find(option => option.value === values.reported_by)}
                                onChange={(selectedOption) => setFieldValue('reported_by', selectedOption?.value || '')}
                                onBlur={handleBlur}
                                error={errors.reported_by}
                                touched={touched.reported_by}
                                isSearch={false}
                                isDisabled={true}
                            />
                        </Col>
                        <Col md={12}>
                            <Select
                                label="Assigned To"
                                placeholder="Please Select"
                                options={userOptions}
                                loading={userDropdownLoading}
                                name="assign_to"
                                value={userOptions.find(option => option.value === values.assign_to)}
                                onChange={(selectedOption) => setFieldValue('assign_to', selectedOption?.value || '')}
                                onBlur={handleBlur}
                                error={errors.assign_to}
                                touched={touched.assign_to}
                                isSearch={false}
                            />
                        </Col>
                        <Col md={12}>
                            <div className='issue_file_upload_wrapper'>
                                <label>Photo & Documents</label>
                                <FileUpload
                                    destination="service-entry"
                                    files={uploadedFiles}
                                    setFiles={setUploadedFiles}
                                    maxFileSize={10}
                                    className='issue_file_upload'
                                />
                            </div>
                        </Col>
                        <Col md={12}>
                            <Button
                                cancelBtn={onClose}
                                submitBtn={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    submitForm();
                                }}
                                loading={createIssueLoading}
                                disabled={createIssueLoading}
                                submitText="Create Issue"
                                type="button"
                            />
                        </Col>
                    </Row>
                </div>
            )}
        </Formik>
    )
}

export default CreateIssue;